const LOCATION_CACHE: Record<string, any[]> = {};

const BUILTIN_AB3 = [
  { id: "loc_52336f91160ce05c", name: "ladies toilet" },
  { id: "loc_80fe3ffed2f77550", name: "electric room" },
  { id: "loc_a31f78646b502c7a", name: "stairs" },
  { id: "loc_ac678186f7c8dfac", name: "104" },
  { id: "loc_d6bafc829f150a3c", name: "staff room" },
  { id: "loc_d257a73cb9f5c78b", name: "101" },
  { id: "loc_f66f754d1f32bd08", name: "lift" },
  { id: "loc_a1bcf11d5c01c300", name: "ahu" },
  { id: "loc_ecd282846a06f875", name: "gents toilet" },
  { id: "loc_4456a7bc684eb2fb", name: "ahu" },
  { id: "loc_fbe936aee2143d0a", name: "105" },
  { id: "loc_0b97fa9badbc3001", name: "toilet for handicap" },
  { id: "loc_c97512b90a1484c0", name: "103" },
  { id: "loc_62e7067600281ff2", name: "102" }
];

export async function loadLocationData(buildingId: string): Promise<any[]> {
  const bid = buildingId.toLowerCase();
  if (LOCATION_CACHE[bid]) return LOCATION_CACHE[bid];
  if (bid === 'ab3') {
    LOCATION_CACHE['ab3'] = BUILTIN_AB3;
    return BUILTIN_AB3;
  }
  try {
    const res = await fetch(`/venue/${bid}_location.json`);
    if (!res.ok) return [];
    const data = await res.json();
    LOCATION_CACHE[bid] = data;
    return data;
  } catch {
    return [];
  }
}

export async function loadAllLocations(): Promise<Record<string, any[]>> {
  const buildings = ['ab1', 'ab2', 'ab3', 'ab4', 'ab5'];
  const results = await Promise.all(buildings.map(b => loadLocationData(b)));
  const map: Record<string, any[]> = {};
  buildings.forEach((b, i) => { map[b] = results[i]; });
  return map;
}
